export default __webpack_public_path__ + "static/media/MTcarpaEspecial_Frente.4ba06028.webp";